import React, { Component } from "react";
import moment from "moment";

import { Field } from "@atlaskit/form";
import { DatePicker } from "@atlaskit/datetime-picker";

import { isValidDate } from "../../utils/consts";

export default class ApplyCardMoveInField extends Component {
  isMoveInDate = () =>
    isValidDate(moment(this.props.value).toDate()) &&
    this.props.value.length !== 0;

  render() {
    return (
      <Field
        className="moveInDate-container"
        id="moveInDate-container"
        label="Desired Move In Date"
        helperText={this.props.helperText}
        isInvalid={!this.isMoveInDate}
      >
        <DatePicker
          id="moveInDate"
          value={this.props.value}
          placeholder={this.props.placeholder}
          onChange={this.props.onChange}
          appearance="default"
        />
      </Field>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/ApplyCardMoveInField/ApplyCardMoveInField.js